<template>
  <div style="padding-top: 60px">
    <popup :message="alertErrMessage" v-if="isAlertErr" @close="isAlertErr = false" />
    <div>
      <div class="head-class" ref="ctn_head">
        <div class="left">
          <div class="d-flex">
            <div class="btn-white-oval font-poppins">
              {{ classDetail.type }}
            </div>
            <div class="btn-white-oval font-poppins">
              {{ classDetail.class_type }}
            </div>
            <div class="btn-white-oval font-poppins">
              {{ toMethode(classDetail.method) }}
            </div>
          </div>
          <p class="text-banner">{{ classDetail.name }}</p>
          <div class="my-7" v-if="classDetail.schedules.length">
            <div class="head-schedule">
              <div style="gap: 5px" class="pb-2">
                <b>Batch {{ classDetail.schedules[0].batch_number }}</b>
                <span>{{ formatDate(classDetail.schedules[0].start_date) }} -
                  {{ formatDate(classDetail.schedules[0].end_date) }}</span>
              </div>
              <div class="line"></div>
              <div style="flex-direction: row">
                <Star :width="25" fill="white" />
                {{ classDetail.level }}
              </div>
              <div style="flex-direction: row">
                <PeopleNew :width="25" fill="white" />
                <span>{{ classDetail.schedules[0].total_audience }} {{ $t('corpAcelerationDetail.header.totalAudience') }}</span>
              </div>
              <div style="flex-direction: row">
                <DateIc2 :width="25" fill="white" />
                <span>{{ classDetail.schedules[0].session }} {{ $t('corpAcelerationDetail.header.session') }}</span>
              </div>
            </div>
            <span v-if="classDetail.is_discount && classDetail.label_discount" style="
                border: 1px solid white;
                border-radius: 30px;
                padding: 4px 12px;
              ">{{ classDetail.label_discount }}</span>
          </div>
          <v-btn depressed color="#FFDE59" @click="goToCheckoutPage()" class="button-daftar" v-if="!isRegistrantClose">
            <span class="font-weight-bold blue-text font-poppins" style="text-transform: none !important">{{
              $t('corporate.heroSection.ctaButtons.registerNow') }}</span>
          </v-btn>
          <v-btn depressed color="#FFFFFF" @click="sendToWa" class="button-daftar" style="margin-left: 30px">
            <span class="font-weight-bold blue-text font-poppins" style="text-transform: none !important">{{
              $t('corporate.heroSection.ctaButtons.consultationFirst') }}</span>
          </v-btn>
          <div class="collaboration">
            {{ $t('corpAcelerationDetail.header.a1') }}
            <div class="image">
              <img :src="classDetail.collaboration_feed" alt="" width="50" />
            </div>
          </div>
        </div>
        <img :src="classDetail.image_url" class="img-banner-1" />
      </div>
      <div class="box-radius">
        <div v-for="(menu, idx) in menuPublicClass" :key="menu.id" class="menu-detail"
          @click="clickActiveMenu(menu.layout, menu.position, menu.name)">
          <span>{{ $t(`corpAcelerationDetail.menuPublicClass[${idx}].name`) }}</span>
          <div :class="{ linesmall: layout === menu.layout }"></div>
        </div>

        <v-btn depressed color="#162CA2" @click="goToCheckoutPage()" style="
            margin-top: 39px;
            padding: 25px;
            border-radius: 16px;
            width: 100%;
          " v-if="!isRegistrantClose">
          <span class="font-weight-bold white--text"
            style="text-transform: none !important; font-size: 16px; letter-spacing: 0 !important">{{
              $t('corporate.heroSection.ctaButtons.registerNow') }}</span>
        </v-btn>
        <v-btn outlined color="gray" style="
            margin-top: 10px;
            padding: 25px;
            border-radius: 16px;
            width: 100%;
          " @click="sendToWa()">
          <span class="font-weight-bold"
            style="text-transform: none !important; font-size: 16px; letter-spacing: 0 !important">{{
              $t('corporate.heroSection.ctaButtons.consultationFirst') }}</span>
        </v-btn>
      </div>
      <!-- Rest of the template remains unchanged -->
      <div class="container-parent" :style="`margin-top: ${classDetail.schedules.length == 0 ? '-490' : '-570'}px`"
        ref="info_kelas">
        <div class="container-detail">
          <span class="addional">{{ $t('corpAcelerationDetail.infoSection.infoClass.title') }}</span>
          <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.infoSection.infoClass.subTitle') }}
          </h5>
          <p class="desc">
            {{ classDetail.description }}
          </p>
        </div>
      </div>
      <div class="bg-container" style="margin-bottom: 50px; background: #f1f6ff" ref="materi_silabus">
        <div class="container-detail" style="margin-top: 45px; padding: 40px 0px">
          <span class="addional">{{ $t('corpAcelerationDetail.infoSection.syllabus.title') }}</span>
          <h5 class="title mb-5" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.infoSection.syllabus.subTitle') }}
          </h5>
          <div v-for="(item, idx) in classDetail.summary_syllabus" :key="idx" class="faq-box"
            @click="toggleSyllabus(idx, item.name)">
            <div class="fax-box-info">
              <p style="width: 90%">{{ item.name }}</p>
              <Arrow :down="item.show" fill="white" />
            </div>
            <p v-if="item.show" v-html="item.value" class="faq-box-active"></p>
          </div>
        </div>
      </div>
      <div class="container-detail" ref="benefit" style="margin-top: 80px">
        <span class="addional">{{ $t('corpAcelerationDetail.infoSection.benefits.title') }}</span>
        <h5 class="title mb-5" style="font-family: 'Poppins', sans-serif !important">
          {{ $t('corpAcelerationDetail.infoSection.benefits.subTitle') }}
        </h5>
        <div class="benefits" v-for="(item, idx) in classDetail.benefits" :key="idx">
          <CheckIc :width="26" :height="26" outline fill="#575966" />
          <span style="font-family: 'Poppins', sans-serif">{{ item }}</span>
        </div>
      </div>
      <div class="container-parent-grdn" style="padding-bottom: 50px">
        <div class="container-detail" ref="tujuan_pelatihan" style="margin-top: 80px">
          <span class="addional">{{ $t('corpAcelerationDetail.infoSection.trainingObjectives.title') }}</span>
          <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.infoSection.trainingObjectives.subTitle') }}
          </h5>
          <div class="learning-objective" ref="learning_objective_ctn" v-html="classDetail.learning_objective"></div>
        </div>
        <div class="container-detail" ref="taget_peserta" style="margin-top: 80px">
          <span class="addional">{{ $t('corpAcelerationDetail.infoSection.targetAudience.title') }}</span>
          <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.infoSection.targetAudience.subTitle') }}
          </h5>
          <ul>
            <li v-for="(item, idx) in classDetail.target_audience" :key="idx">
              {{ item.level }}
            </li>
          </ul>
        </div>
      </div>

      <div class="container-parent" ref="kenapa_hicolleagues" style="margin: 50px 0">
        <div class="container-detail">
          <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.whyHiColleagues.title') }}
          </h5>
          <div class="why-hicoll mt-5">
            <div class="card-hicol" v-for="(item, idx) in $t('corpAcelerationDetail.whyHiColleagues.items')" :key="idx">
              <div>
                <img :src="item.img" width="70" alt="Ctn" />
              </div>
              <div>
                <h3>{{ item.title }}</h3>
                <p style="color: #36373f">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="container-parent mt-10" ref="metode_belajar" style="margin: 80px 0">
        <div class="container-detail">
          <span class="addional">{{ $t('corpAcelerationDetail.learningMethod.additionalTitle') }}</span>
          <h5 class="title" style="
          font-family: 'Poppins', sans-serif !important;
          line-height: 30px;
        ">
            {{ $t('corpAcelerationDetail.learningMethod.title') }}
          </h5>
          <div class="why-hicoll mt-8">
            <div v-for="(item, idx) in $t('corpAcelerationDetail.learningMethod.items')" :key="idx">
              <div class="circle-yellow">
                <img :src="item.img" width="28" alt="Ctn" />
              </div>
              <h3 class="mt-3">{{ item.title }}</h3>
              <p style="color: #36373f">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="container-parent mt-10" ref="timeline_belajar">
        <div class="container-detail">
          <span class="addional">{{ $t('corpAcelerationDetail.scheduleSection.schedule') }}</span>
          <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('corpAcelerationDetail.scheduleSection.schedule2') }}
          </h5>
          <div class="timeline-bootcamp mt-5" v-for="(item, idx) in classDetail.schedules" :key="idx">
            <div style="
        padding: 20px 65px;
        display: flex;
        align-items: center;
        gap: 20px;
      ">
              <p class="batch">{{ $t('corpAcelerationDetail.scheduleSection.batch') }} {{ item.batch_number }}</p>
              <p class="schedule">
                {{ formatDate(item.start_date) }} - {{ formatDate(item.end_date) }}
              </p>
              <p class="discount" v-if="classDetail.is_discount">
                {{ $t('corpAcelerationDetail.scheduleSection.discountLabel') }}
              </p>
            </div>
            <div class="line mt-2"></div>
            <div class="info-schadule">
              <div class="info-schadule-ctn">
                <Star :width="30" fill="#7B7E8C" />
                <span> {{ classDetail.level }}</span>
              </div>
              <div class="info-schadule-ctn">
                <PeopleNew :width="30" fill="#7B7E8C" />
                <span>{{ item.total_audience }} {{ $t('corpAcelerationDetail.scheduleSection.infoSchedule.totalAudience') }}</span>
              </div>
              <div class="info-schadule-ctn">
                <DateIc2 :width="30" fill="#7B7E8C" />
                <span>{{ item.session }} {{ $t('corpAcelerationDetail.scheduleSection.infoSchedule.session') }}</span>
              </div>
              <div class="info-schadule-ctn">
                <MethodeNew :width="30" fill="#7B7E8C" />
                <span> {{ classDetail.method | toMethode }}</span>
              </div>
            </div>
            <div class="line mt-4"></div>
            <div class="info-schadule mb-4" style="display: block">
              <v-row>
                <v-col cols="8">
                  <div class="info-schadule-ctn">
                    <ClockIc :width="25" fill="#7B7E8C" />
                    <span style="padding-top: -10px">{{ $t('corpAcelerationDetail.scheduleSection.executionTime') }}</span>
                  </div>
                  <ul class="shadule">
                    <li>
                      <div style="display: flex; gap: 20px; align-items: center">
                        <span class="font-poppins">{{ classDetail.days }}</span>
                        <span>:</span>
                        <span class="font-poppins">{{ classDetail.hours }}</span>
                      </div>
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <v-row class="price-ctn">
                <v-col>
                  <div class="early-bird">
                    <div class="head">
                      <span class="eb">{{ $t('corpAcelerationDetail.scheduleSection.pricing.normalPrice') }}</span>
                    </div>
                    <div style="padding: 20px 30px; height: 130px">
                      <h1 style="margin: 0; color: #162ca2">
                        {{ classDetail.price | toCurrency }}
                      </h1>
                    </div>
                  </div>
                </v-col>
                <v-col>
                  <div class="early-bird" v-if="classDetail.is_discount">
                    <div class="head" style="background-color: #fef3c7">
                      <span class="eb">{{ $t('corpAcelerationDetail.scheduleSection.pricing.discountPrice') }}</span>
                    </div>
                    <div style="padding: 20px 30px; height: 130px">
                      <p style="color: #b80f0a; font-size: 16px; margin: 0">
                        <del>{{ classDetail.price | toCurrency }}</del>
                      </p>
                      <h1 style="margin: 0; color: #162ca2">
                        {{ toCurrency(classDetail.price - classDetail.discount_price) }}
                      </h1>
                      <p style="margin: 0; font-size: 13px">
                        {{ $t('corpAcelerationDetail.scheduleSection.pricing.validFrom') }}
                        {{ formatDate(classDetail.start_discount_date) }}
                        -
                        {{ formatDate(classDetail.end_discount_date) }}
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <div class="close-date">
                <span>
                  {{ $t('corpAcelerationDetail.scheduleSection.registrationCloseDate') }}
                  <b style="color: #b80f0a">{{ formatDate(classDetail.registration_close_date) }}</b>
                </span>
                <v-btn depressed color="#162CA2" @click="goToCheckoutPage(item)" class="button-daftar"
                  v-if="!isRegistrantClose">
                  <span class="font-weight-bold font-poppins" style="text-transform: none !important; color: white">{{
                    $t('corporate.heroSection.ctaButtons.registerNow') }}</span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-container" style="background: #f1f6ff; border-radius: 80px 80px 0 0" ref="faq">
        <div class="container-detail" style="margin-top: 45px; padding: 40px 0px; min-width: 70%">
          <h5 class="title mb-5" style="font-family: 'Poppins', sans-serif !important">
            Frequently Asked Question
          </h5>
          <div class="col-lg-9" style="margin-top: -10px; min-width: 100%">
            <v-expansion-panels flat class="faq-card" style="padding: 20px; background-color: #f1f6ff">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 15px; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow style="margin-right: 35px" />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" style="margin-right: 35px" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content style="margin-left: 15px">
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="btn-stoke-blue" @click="goToFaq">
            <span class="font-poppins">{{ $t('corporate.a4') }}</span>
            <ArrowLong />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import goTo from "vuetify/lib/services/goto";
import Arrow from "@/assets/icons/Arrow.vue";
import CheckIc from "@/assets/icons/Check.vue";
import ClockIc from "@/assets/icons/Clock.vue";
import DateIc2 from "@/assets/icons/DateIc2.vue";
import PeopleNew from "@/assets/icons/PeopleNew.vue";
import Star from "@/assets/icons/Star.vue";
import MethodeNew from "@/assets/icons/MethodeNew.vue";
import Popup from "@/components/others/Popup.vue";

export default {
  name: "DetailClassAccDesktop",
  components: {
    Arrow,
    ArrowLong,
    CheckIc,
    ClockIc,
    DateIc2,
    PeopleNew,
    Star,
    MethodeNew,
    Popup,
  },
  data() {
    return {
      // methodLearning: [
      //   {
      //     img: "/img/bootcamp/chat.png",
      //     title: "Join Community Group",
      //     desc: "Tersedia grup Telegram untuk memfasilitasi kolaborasi, konsultasi, dan pertukaran informasi antara peserta, trainer, dan admin grup.",
      //   },
      //   {
      //     img: "/img/bootcamp/zoom.png",
      //     title: "Live Class via Zoom",
      //     desc: "Peserta akan mengikuti sesi pembelajaran secara daring menggunakan Zoom.",
      //   },
      //   {
      //     img: "/img/bootcamp/lms.png",
      //     title: "Access to LMS",
      //     desc: "Peserta mendapatkan akses LMS untuk mempermudah proses pembelajaran selama bootcamp.",
      //   },
      //   {
      //     img: "/img/bootcamp/partical.png",
      //     title: "Practical Learning",
      //     desc: "Peserta belajar melalui materi dan langsung menerapkannya dalam pengerjaan proyek yang relevan.",
      //   },
      //   {
      //     img: "/img/bootcamp/sharing.png",
      //     title: "Sharing Session",
      //     desc: "Peserta dapat berdiskusi dan mendengarkan pengalaman langsung dari trainer ketika sesi pembelajaran berlangsung.",
      //   },
      //   {
      //     img: "/img/bootcamp/coumunication.png",
      //     title: "Live Consultation",
      //     desc: "Peserta berkesempatan mendapatkan bimbingan dan mentoring pribadi langsung dari trainer.",
      //   },
      //   {
      //     img: "/img/bootcamp/project.png",
      //     title: "Final Project & Exam",
      //     desc: "Pada akhir pembelajaran, peserta wajib untuk mengerjakan proyek akhir dan ujian untuk mengukur pemahaman peserta.",
      //   },
      // ],
      classDetail: {
        summary_syllabus: [],
        benefits: [],
        learning_objective: [],
        target_audience: [],
        price: [],
        is_discount: false,
        discount_price: 0,
        end_discount_date: "",
        schedules: [],
        level: "",
        days: "",
        hours: "",
      },
      alertErrMessage: "",
      isAlertErr: false,
      isRegistrantClose: false,
      questions: [],
      layout: "info-kelas",
    };
  },
  metaInfo() {
    return {
      title: `HiColleagues | ${this.classDetail.name}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.classDetail.meta_description}`
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `HiColleagues | ${this.classDetail.name}`
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `${this.classDetail.meta_description}`
        }
      ]
    }
  },
  computed: {
    menuPublicClass() {
      // Dynamically generate menuPublicClass from translations
      return this.$t('corpAcelerationDetail.menuPublicClass').map((item, idx) => ({
        name: item.name,
        id: idx + 1, // Unique IDs starting from 1
        position: 0, // Will be set in mappingHeightOfElement
        layout: item.layout
      }));
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getDetailClass();
      this.getFaq();
    },
  },
  methods: {
    mappingHeightOfElement() {
      let point = this.$refs.ctn_head.clientHeight;
      this.menuPublicClass[0].position = point;
      point += this.$refs.info_kelas.clientHeight;
      this.menuPublicClass[1].position = point;
      point += this.$refs.materi_silabus.clientHeight;
      this.menuPublicClass[2].position = point;
      point += this.$refs.benefit.clientHeight;
      this.menuPublicClass[3].position = point;
      point += this.$refs.tujuan_pelatihan.clientHeight;
      this.menuPublicClass[4].position = point;
      point += this.$refs.taget_peserta.clientHeight;
      this.menuPublicClass[5].position = point;
      point += this.$refs.kenapa_hicolleagues.clientHeight + 200;
      this.menuPublicClass[6].position = point;
      point += this.$refs.metode_belajar.clientHeight + 220;
      this.menuPublicClass[7].position = point;
      point += this.$refs.timeline_belajar.clientHeight;
      this.menuPublicClass[8].position = point;
    },
    clickActiveMenu(layout, position, name) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Menu Click - ${name}`,
        value: 1,
      });
      this.layout = layout;
      goTo(Number(position + 10));
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Free Consultation - WhatsApp',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    goToCheckoutPage(schedule) {
      
      if (this.isRegistrantClose) {
        this.alertErrMessage = "Pendaftaran sudah ditutup";
        this.isAlertErr = true;
        return;
      }
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Register Now - ${this.classDetail.name}`,
        value: 1,
      });
      if (!schedule) {
        schedule = this.classDetail.schedules[0];
      }
      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: "ACCELERATION_CLASS",
        type: this.classDetail.type,
        type_class: this.classDetail.class_type,
        is_discount: this.classDetail.is_discount,
        discount_price: this.classDetail.discount_price,
        collaboration_feed: this.classDetail.collaboration_feed,
        schedule,
        days: this.classDetail.days,
        methode: this.classDetail.method,
        category_id: this.classDetail.category_id,
      });
      localStorage.setItem("checkout", req);
      this.$router.push("/certification/checkout");
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs',
        value: 1,
      });
      this.$router.push('/faq');
    },
    openFaq(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title}`,
        value: 1,
      });
      const valDef = this.questions[index].active;
      this.questions.forEach((e) => {
        e.active = false;
      });
      this.questions[index].active = !valDef;
    },
    toggleSyllabus(index, name) {
      this.$gtag.event('click', {
        event_category: 'Syllabus',
        event_label: `Toggle Syllabus - ${name}`,
        value: 1,
      });
      this.classDetail.summary_syllabus[index].show = !this.classDetail.summary_syllabus[index].show;
    },
    async getDetailClass() {
      await this.$http
        .get(`/v1/class-detail/${this.$route.params.slug_name}`)
        .then((response) => {
          const data = response.data.data.class_detail;
          this.classDetail = {
            ...data,
            summary_syllabus: data.summary_syllabus
              ? data.summary_syllabus.map((item) => ({
                ...item,
                show: true,
              }))
              : [],
          };
          this.isRegistrantClose = new Date(this.classDetail.registration_close_date) <= new Date();
          setTimeout(() => {
            this.mappingHeightOfElement();
          }, 1000);
        })
        .catch((err) => console.error(err));
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(
          `/v1/faq?category=CLASS_ACCELERATION&is_main=true`
        );
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      if (value <= 0) {
        return "FREE";
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === "online") {
        return this.$i18n.locale === 'id' ? "Daring" : "Online";
      } else if (value.toLowerCase() === "offline") {
        return this.$i18n.locale === 'id' ? "Luring" : "Offline";
      } else {
        return value;
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getDetailClass();
    this.getFaq();
    window.scrollTo(0, 0);
  },
};
</script>

<style src="./detailClassAcceleration.css" scoped></style>